import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TenantCostDetailsComponent} from './tenant-cost-details.component';
import {RouterModule} from '@angular/router';
import {SharedModule} from 'src/app/shared/shared.module';
import {MatDividerModule} from '@angular/material/divider';
import {SearchFilterModule} from 'src/app/components/search-filter/search-filter.module';
import {DropdownFilterModule} from 'src/app/components/dropdown-fliter/dropdown-filter.module';
import {TenantCostDetailsRoutingModule} from './tenant-cost-details-routing.module';

@NgModule({
  declarations: [
    TenantCostDetailsComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule, MatDividerModule, SearchFilterModule, DropdownFilterModule, TenantCostDetailsRoutingModule,
  ]
})
export class TenantCostDetailsModule {
}
